import axios from 'Src/helpers/api/axiosInstance';
import { AxiosRequestConfig } from 'axios';
import { getSuperAdminSessionKey } from 'Src/helpers/session/superadminSession';

function getSuperAdminRequestConfig(config: AxiosRequestConfig = {}): AxiosRequestConfig {
  const sessionKey = getSuperAdminSessionKey();

  return {
    ...config,
    headers: {
      ...(config.headers || {}),
      asid: sessionKey
    }
  };
}

export function superAdminGet<T = any>(url: string, config?: AxiosRequestConfig): Promise<T> {
  return axios
    .get(`${window.apiBase}/superadmin${url}`, getSuperAdminRequestConfig(config))
    .then(response => response.data);
}

export function superAdminPost<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
  return axios
    .post(`${window.apiBase}/superadmin${url}`, data, getSuperAdminRequestConfig(config))
    .then(response => response.data);
}

export function superAdminPut<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<T> {
  return axios
    .put(`${window.apiBase}/superadmin${url}`, data, getSuperAdminRequestConfig(config))
    .then(response => response.data);
}

export function superAdminDelete<T = any>(url: string, config?: AxiosRequestConfig): Promise<T> {
  return axios
    .delete(`${window.apiBase}/superadmin${url}`, getSuperAdminRequestConfig(config))
    .then(response => response.data);
}
